import { Component } from '@angular/core';

@Component({
  selector: 'greco-cart-items',
  templateUrl: './cart-items.component.html',
  styleUrls: ['./cart-items.component.scss'],
})
export class CartItemsComponent {}
